import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Radio, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function SystemMode() {
  const [state, setState] = useState(null);

  const load = () => api.get("/system/mode").then((r) => setState(r.data));
  useEffect(() => { load(); }, []);

  const change = async (mode) => {
    try {
      await api.post("/system/mode", { mode });
      toast.success(`Modo del sistema → ${mode}`);
      load();
    } catch {
      toast.error("Error");
    }
  };

  if (!state) return <div className="p-8 text-[var(--text-dim)]">Cargando…</div>;

  return (
    <div className="p-8 space-y-6" data-testid="system-page">
      <div className="border-b border-[var(--border)] pb-5">
        <div className="label-mono mb-2">CONTROL GLOBAL</div>
        <h1 className="font-display font-black text-4xl tracking-tight">Modo del Sistema</h1>
        <p className="text-sm text-[var(--text-dim)] mt-1">
          Define la postura de autonomía global. Cambio inmediato para todos los agentes.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
        {state.modes.map((m) => {
          const active = state.mode === m.id;
          return (
            <button
              key={m.id}
              onClick={() => change(m.id)}
              className={`text-left border p-5 relative transition-all ${
                active ? "border-2" : "border-[var(--border)] hover:border-[var(--accent)]/40"
              }`}
              style={{ borderColor: active ? m.color : undefined, background: active ? `${m.color}15` : "var(--surface)" }}
              data-testid={`mode-${m.id}`}
            >
              <div className="flex items-start justify-between mb-4">
                <Radio className="w-5 h-5" style={{ color: m.color }} />
                {active && <CheckCircle2 className="w-4 h-4" style={{ color: m.color }} />}
              </div>
              <div className="label-mono mb-2" style={{ color: active ? m.color : undefined }}>
                {active ? "ACTIVO" : "DISPONIBLE"}
              </div>
              <div className="font-display font-black text-xl mb-2 leading-tight" style={{ color: active ? m.color : "white" }}>
                {m.label}
              </div>
              <div className="text-xs text-[var(--text-dim)] leading-relaxed">{m.desc}</div>
            </button>
          );
        })}
      </div>

      <div className="border border-[var(--warn)] bg-[var(--warn)]/5 p-5" data-testid="system-warning">
        <div className="label-mono mb-2" style={{ color: "var(--warn)" }}>ADVERTENCIA</div>
        <div className="text-sm text-white leading-relaxed">
          Cambiar a <b>Incident Lockdown</b> detiene todos los agentes excepto CISO y Audit.
          Úsalo solo ante compromiso real. Cada cambio queda auditado con riesgo crítico.
        </div>
      </div>
    </div>
  );
}
